import { Component, inject, OnInit } from '@angular/core';
import { ButtonSizes, ButtonStyles, ButtonTypes } from '../../../button/button.component';
import { EmailTemplatePreviewFieldConfig } from '../../../shared/models/generated/ziroModels';
import { EmailService } from '../../shared/services/email.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentClusterContext } from '../../../shared/contexts/current-cluster.context';
import { EmailTemplatePreviewsFieldConfigResource } from '../../shared/resources/field-config/email-template-previews-field-config.resource';
import { ZiroIcons, ZiroStackedIcons } from '../../../shared/models/ziro-icons.enum';
import { DatatableColumn, DatatableRow } from '../../../shared/tables/datatable/datatable.models';

interface EmailTemplateRow extends DatatableRow {
  emailTemplateName: string;
  recipients: string[];
}

@Component({
  selector: 'ziro-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.scss'],
  standalone: false,
})
export class SendEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private emailService = inject(EmailService);
  private emailTemplatePreviewsFieldConfigResource = inject(EmailTemplatePreviewsFieldConfigResource);
  private currentClusterContext = inject(CurrentClusterContext);

  ZiroStackedIcons = ZiroStackedIcons;
  ziroIcons = ZiroIcons;
  ButtonStyles = ButtonStyles;
  ButtonSizes = ButtonSizes;

  columns: DatatableColumn<EmailTemplateRow>[] = [
    {
      name: 'emailTemplateName',
      label: 'tkey;helpdesk.send_email.table.email_template_name',
      columnCharacterWidth: 60,
    },
    {
      name: 'recipients',
      label: 'tkey;helpdesk.send_email.table.recipients',
      columnCharacterWidth: 50,
      sortFn: (a: string[], b: string[]) => (a[0] ?? '').localeCompare(b[0] ?? ''),
    },
  ];

  tableRows: EmailTemplateRow[];
  enduserUsername: string;
  cucmServerId: number;
  isLoading = true;

  ngOnInit(): void {
    this.enduserUsername = this.route.snapshot.params.username;

    this.currentClusterContext.state$.subscribe((currentCluster) => {
      this.cucmServerId = currentCluster.cucmServerId;
      this.emailTemplatePreviewsFieldConfigResource.get(this.enduserUsername, this.cucmServerId).subscribe((emails) => {
        this.tableRows = emails.map((email) => this._mapEmailPreviewToTableRow(email));
        this.isLoading = false;
      });
    });
  }

  goHome(): void {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  private _mapEmailPreviewToTableRow(emailTemplatePreview: EmailTemplatePreviewFieldConfig): EmailTemplateRow {
    return {
      emailTemplateName: emailTemplatePreview.emailTemplateName,
      recipients: emailTemplatePreview.recipients,
      badges: {
        recipients: {
          values: emailTemplatePreview.recipients.map((recipient) => ({
            label: recipient,
          })),
        },
      },
      actions: [
        {
          type: ButtonTypes.BUTTON,
          style: ButtonStyles.OUTLINE_PRIMARY,
          icon: ZiroIcons.NEXT,
          dataAutomation: 'preview-email-button',
          onClick: () => this._openPreviewModal(emailTemplatePreview),
        },
      ],
    };
  }

  private _openPreviewModal(emailTemplatePreview: EmailTemplatePreviewFieldConfig): void {
    this.emailService.openEmailPreviewModal(this.enduserUsername, emailTemplatePreview);
  }
}
